import { Injectable } from '@angular/core';
import { LicenseInfo } from '@common/current-customer/current-customer.query';
import { CurrentCustomerService } from '@common/current-customer/current-customer.service';
import { PhAuthService } from '@common/ph-auth';
import { PhConfigLoaderService } from '@common/ph-config-loader';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable()
export class AppSwitcherService {
  customer$ = this.currentCustomerSrv.currentCustomer$.pipe(shareReplay(1));
  licenses$: Observable<LicenseInfo>;
  subdomain$: Observable<string>;

  caAvailable$: Observable<boolean>;
  caTplURL$: Observable<string>;
  caURL$: Observable<string>;

  assetsAvailable$: Observable<boolean>;
  assetsTplURL$: Observable<string>;
  assetsURL$: Observable<string>;

  workflowAvailable$: Observable<boolean>;
  workflowTplURL$: Observable<string>;
  workflowURL$: Observable<string>;

  connectTplURL$: Observable<string>;
  connectURL$: Observable<string>;

  duressAvailable$: Observable<boolean>;
  duressTplURL$: Observable<string>;
  duressURL$: Observable<string>;

  constructor(
    private config: PhConfigLoaderService,
    private currentCustomerSrv: CurrentCustomerService,
    private phAuthSrv: PhAuthService
  ) {
    this.licenses$ = this.customer$.pipe(map(customerData => customerData?.licenseInfo));
    this.subdomain$ = this.customer$.pipe(map(customerData => customerData?.subdomain));

    this.caTplURL$ = this.config.getConfig$('FRONTEND_CA_URL');
    this.assetsTplURL$ = this.config.getConfig$('FRONTEND_ASSETS_RT_URL');
    this.workflowTplURL$ = this.config.getConfig$('FRONTEND_WRT_URL');
    this.connectTplURL$ = this.config.getConfig$('FRONTEND_CONNECT_RT_HOME_URL');
    this.duressTplURL$ = this.config.getConfig$('FRONTEND_DURESS_RT_URL');

    this.assetsAvailable$ = combineLatest([
      this.phAuthSrv.scopes$.pipe(map(scopes => scopes.includes('access:art'))),
      this.licenses$.pipe(map(licenses => !!licenses?.is_assets_rt_enabled)),
    ]).pipe(map(([permission, license]) => permission && license));

    this.assetsURL$ = combineLatest([this.assetsTplURL$, this.subdomain$]).pipe(
      map(([tpl, subdomain]) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.workflowAvailable$ = combineLatest([
      this.phAuthSrv.scopes$.pipe(map(scopes => scopes.includes('access:wrt'))),
      this.licenses$.pipe(map(licenses => !!licenses?.is_workflow_rt_enabled)),
    ]).pipe(map(([permission, license]) => permission && license));

    this.caAvailable$ = this.phAuthSrv.scopes$.pipe(map(scopes => scopes.includes('access:ca')));

    this.workflowURL$ = combineLatest([this.workflowTplURL$, this.subdomain$]).pipe(
      map(([tpl, subdomain]) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.connectURL$ = combineLatest([this.connectTplURL$, this.subdomain$]).pipe(
      map(([tpl, subdomain]) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.caURL$ = combineLatest([this.caTplURL$, this.subdomain$]).pipe(
      map(([tpl, subdomain]) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.duressAvailable$ = combineLatest([
      this.phAuthSrv.scopes$.pipe(map(scopes => scopes.includes('access:drt'))),
      this.licenses$.pipe(map(licenses => !!licenses?.is_duress_rt_enabled)),
    ]).pipe(map(([permission, license]) => permission && license));

    this.duressURL$ = combineLatest([this.duressTplURL$, this.subdomain$]).pipe(
      map(([tpl, subdomain]) => tpl.replace('[CUSTOMER]', subdomain))
    );
  }
}
